
import { defineComponent, PropType } from 'vue';
import Card from '@/components/global/Card.vue';

export default defineComponent({
  components: { Card },
  props: {
    transcriptionInfo: String,
    transcription: Array as PropType<Array<string>>,
    selectedWord: Number,
    makeLinks: Boolean,
  },
  emits: ['wordSelected'],
});
